import { useTranslation } from "@1f/react-sdk";
import sharedDatas from "../../businessLogic/sharedDatas";
import { bsaRischio } from "../../businessLogic/constants/securityAreas";
import { useAreaPermissions } from "../../businessLogic/hooks/useAreaPermissions";
import Table from "@vapor/react-material/Table";
import TableRow from "@vapor/react-material/TableRow";
import TableCell from "@vapor/react-material/TableCell";  
import IconButton from "@vapor/react-material/IconButton";
import Box from "@vapor/react-material/Box";
import ExtendedTypography from "@vapor/react-extended/ExtendedTypography";
import Stack from "@vapor/react-material/Stack";

import {    
    ModeEdit as ModeEditIcon,
    Delete as DeleteIcon,    
} from "@mui/icons-material";
import { v4 as uuidv4 } from "uuid";

export const RischiList = ({rischiList,selectedRischio,utentiList,selectedPrestazione, onDeleteRischio,onSelectRischio }) => {
    const { t } = useTranslation();
    const tenantTypeId = sharedDatas.getPropertyByName("userModel").tenantTipoId; 
    const { permissions, getPermissions } = useAreaPermissions(bsaRischio);

    // Define the delete handler
    const handleDeleteRischioClick = (rischio) => {
        if (!getPermissions().canDelete) return;
        if (onDeleteRischio) {
            onDeleteRischio(rischio);
        }
    };

    const handleSelectedRischioClick = (rischio) => {
        if (onSelectRischio) {
            onSelectRischio(rischio);
        }
    }

    return (
        <Table>
            {rischiList.map((rischio, index) => (
                <TableRow
                    key={uuidv4()}
                    sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                    }}
                    hover
                    selected={rischio.id === selectedRischio?.id}
                >
                <TableCell
                    key={uuidv4()}
                    component="th"
                    scope="row"
                >
                    <Stack
                    direction="row"
                    justifyContent="center"
                    alignItems="center"
                    >
                    <Stack direction="column">
                        <ExtendedTypography
                        variant="titleSmall"
                        color="primary.main"
                        >
                        {t("rischio.rischioForm.effBy")}{" "}
                        {
                            utentiList.filter(
                            (x) => x.userId === rischio.providedBy
                            )[0].completeName
                        }{" "}
                        {t("rischio.rischioForm.inDt")}{" "}
                        {new Date(rischio.date).toLocaleDateString()}
                        </ExtendedTypography>
                        <ExtendedTypography
                        variant="body"
                        color="text.secondary"
                        >
                        {tenantTypeId === 3 ? 
                            `Totale complessivo A: ${rischio.sp_a_subTotal}` :
                            `${t("valutazione.form.rischioInerente")}${" "}
                            ${t("rischio.rischioForm.pond")}${" "}
                            ${rischio.ef_ri_total}`
                        }
                        </ExtendedTypography>
                        <ExtendedTypography
                        variant="body"
                        color="text.secondary"
                        >
                        {tenantTypeId === 3 ? 
                            `Totale complessivo B: ${rischio.sp_b_subTotal}` :
                            `${t("rischio.rischioForm.rskSpecPond")}${" "}
                            ${rischio.ef_sp_total}`
                        }                                    
                        </ExtendedTypography>
                        <ExtendedTypography
                        variant="body"
                        color="text.secondary"                              
                        >
                        {tenantTypeId === 3 ? 
                            `Totale: ${rischio.sp_a_subTotal+rischio.sp_b_subTotal}` : 
                            `${t("valutazione.form.totale")}:${" "}
                            ${rischio.ef_total}` 
                        }                                    
                        </ExtendedTypography>
                        <ExtendedTypography
                        variant="body"
                        color="text.secondary"
                        >
                        {t("rischio.rischioForm.nxtVer")}{" "}
                        {new Date(
                            rischio.dataControlloCostante
                        ).toLocaleDateString()}
                        </ExtendedTypography>
                    </Stack>
                    <Box sx={{ flexGrow: 1 }} />
                    <Stack direction="row">
                        <IconButton
                        edge="end"
                        aria-label="select"
                        color="primary"
                        onClick={() =>
                            handleSelectedRischioClick(rischio)
                        }
                        sx={{ mr: "1px !important" }}
                        >
                            <ModeEditIcon fontSize="small" />
                        </IconButton>
                        {permissions.canDelete && <IconButton
                            edge="end"
                            aria-label="delete"
                            color="error"
                            onClick={() =>
                                handleDeleteRischioClick(rischio)
                            }
                            sx={{ mr: "1px !important" }}
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>}
                    </Stack>
                    </Stack>
                </TableCell>
                </TableRow>                                   
            ))}
        </Table>
    )
}